var F = {
  white: "#FFFFFF",
  black: "#001E2B",
  gray: {
    dark4: "#112733",
    dark3: "#1C2D38",
    dark2: "#3D4F58",
    dark1: "#5C6C75",
    base: "#889397",
    light1: "#C1C7C6",
    light2: "#E8EDEB",
    light3: "#F9FBFA"
  },
  green: {
    dark3: "#023430",
    dark2: "#00684A",
    dark1: "#00A35C",
    base: "#00ED64",
    light1: "#71F6BA",
    light2: "#C0FAE6",
    light3: "#E3FCF7"
  },
  purple: {
    dark3: "#2D0B59",
    dark2: "#5E0C9E",
    base: "#B45AF2",
    light2: "#F1D4FD",
    light3: "#F9EBFF"
  },
  blue: {
    dark3: "#0C2657",
    dark2: "#083C90",
    dark1: "#1254B7",
    base: "#016BF8",
    light1: "#0498EC",
    light2: "#C3E7FE",
    light3: "#E1F7FF"
  },
  yellow: {
    dark3: "#4C2100",
    dark2: "#944F01",
    base: "#FFC010",
    light2: "#FFEC9E",
    light3: "#FEF7DB"
  },
  red: {
    dark3: "#5B0000",
    dark2: "#970606",
    base: "#DB3030",
    light1: "#FF6960",
    light2: "#FFCDC7",
    light3: "#FFEAE5"
  }
},
    a = {
  white: "#FFFFFF",
  black: "#061621",
  focus: "#019EE2",
  gray: {
    dark3: "#21313C",
    dark2: "#3D4F58",
    dark1: "#5D6C74",
    base: "#89979B",
    light1: "#B8C4C2",
    light2: "#E7EEEC",
    light3: "#F9FBFA"
  },
  green: {
    dark3: "#0B3B35",
    dark2: "#116149",
    dark1: "#09804C",
    base: "#13AA52",
    light2: "#C3E7CA",
    light3: "#E4F4E4"
  },
  blue: {
    dark3: "#0D324F",
    dark2: "#1A567E",
    base: "#007CAD",
    light1: "#9DD0E7",
    light2: "#C5E4F2",
    light3: "#E1F2F6"
  },
  yellow: {
    dark3: "#543E07",
    dark2: "#86681D",
    base: "#FFDD49",
    light2: "#FEF2C8",
    light3: "#FEF7E3"
  },
  red: {
    dark3: "#570B08",
    dark2: "#8F221B",
    dark1: "#B1371F",
    base: "#CF4A22",
    light2: "#F9D3C5",
    light3: "#FCEBE2"
  }
};
export { F as palette, a as uiColors };